<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">科研项目&gt;</div>
      </div>

      <div class="body_content">
        <div class="body_top">
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#publishedProject" style="width: 140px">
            申请项目
          </button>
          <div class="searcharea">
            <a href="#" @click="downloadFile('template/申请书.docx')">申请书模板下载</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="#" @click="downloadFile('template/评审表 活页.docx')">活页模板下载</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-control" placeholder="名称"  v-model="searchParams.title"/>
            <button type="button" class="btn btn-default btn_option" @click="initDataList()">查询</button>
          </div>
        </div>
        <div class="classList_div">
          <table class="table table-striped table-bordered table_trainingManage" style="table-layout: fixed;">
            <thead>
            <tr>
              <th width="20%">项目名称</th>
              <th width="20%">科室/人员</th>
              <th width="30%">项目时间</th>
              <th width="10%">状态</th>
              <th width="15%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(d, index) in dataList" :key="index">
              <td style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{d.title}}</td>
              <td>
                <p v-if="d.dept">科室：{{d.dept}}</p>
                <p v-if="d.personCharge">负责人：{{d.personCharge}}</p>
                <p v-if="d.personPart">参与人：{{d.personPart}}</p>
              </td>
              <td>
                <p v-if="!d.approvalDate">创建时间：{{d.createTime}}</p>
                <p v-if="d.approvalDate">立项时间：{{d.approvalDate}}</p>
                <p v-if="d.mediumStartDate">中期评审：{{d.mediumStartDate}} -- {{d.mediumEndDate}}</p>
                <p v-if="d.finalStartDate">结项评审：{{d.finalStartDate}} -- {{d.finalEndDate}}</p>
              </td>
              <td>
                {{statuses[d.status]}}
              </td>
              <td>
                <a v-if="d.status == '11' && (new Date(d.mediumStartDate + ' 00:00:00') <= new Date())
                && (new Date() <= new Date(d.mediumEndDate + ' 23:59:59'))"
                   href="#" @click="projectView(d,'中期审核申请')">中期审核申请</a>
                <a v-if="d.status == '21' && (new Date(d.finalStartDate + ' 00:00:00') <= new Date())
                && (new Date() <= new Date(d.finalEndDate + ' 23:59:59'))"
                   href="#" @click="projectView(d,'结项审核申请')">结项审核申请</a>
                <a href="#" @click="projectView(d,'查看')">查看</a>
              </td>
            </tr>
            </tbody>
          </table>
          <page-view v-bind="searchParams"></page-view>

          <!--待申请课题-->
          <div class="modal fade" id="publishedProject" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog" style="width: 750px;" >
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    待申请课题
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>

                    <table class="table table-striped table-bordered table_trainingManage">
                      <thead>
                      <tr>
                        <th width="40%">项目名称</th>
                        <th width="40%">项目来源</th>
                        <th width="20%">操作</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(d, index) in publicshedDataList" :key="index">
                        <td>{{d.title}}</td>
                        <td>{{d.source}}</td>
                        <td>
                          <a href="#" @click="applyProject(d)">申请</a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <page-view v-bind="publishedSearchParams"></page-view>
                  </div>
                </div>
                <div class="modal-footer">
<!--                  <button type="button" class="btn btn-default" @click="saveData()">确定</button>-->
                  <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
                </div>
              </div>
            </div>
          </div>

          <!--项目申请-->
          <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    项目申请
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>
                    <label>科室：</label>
                    <input type="text" class="form-control" v-validate="'required|maxL:100'" data-vv-scope="scope" data-vv-as="科室" name="dept" placeholder="输入科室" v-model="data.dept">
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('scope.dept') }}</span>

                    <label>负责人：</label>
                    <input type="text" class="form-control" v-validate="'maxL:30'" data-vv-scope="scope" data-vv-as="负责人" name="personCharge" placeholder="输入负责人" v-model="data.personCharge" autocomplete="off">
                    <span class="spanRed"></span>
                    <span class="validateTip">{{ errors.first('scope.personCharge') }}</span>

                    <label>参与人：</label>
                    <input type="text" class="form-control" v-validate="'maxL:100'" data-vv-scope="scope" data-vv-as="参与人" name="personPart" placeholder="输入参与人" v-model="data.personPart" autocomplete="off">
                    <span class="spanRed"></span>
                    <span class="validateTip">{{ errors.first('scope.personPart') }}</span>

                    <div class="editVideoDiv" v-if="option_flag == 'edit'" style="margin-top: 5px;">
                      <label>申请书：</label>
                      <p class="fileListP" v-for="(att, index) in edit_apply_file_data" :key="index">
                        <a @click="openFileModal(att.filePath)">{{att.fileName}}</a>
                        <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile('apply', att.id)"></span>
                      </p>
                    </div>
                    <uploader :options="upload.applyOptions" :file-status-text="upload.statusText"
                              class="uploader-example" ref="applyFile" style="margin-top: 5px;">
                      <uploader-unsupport></uploader-unsupport>
                      <uploader-drop>
                        <p>拖拽申请书至此处</p>
                        <uploader-btn :attrs="upload.attrs.file">上传申请书</uploader-btn>
                      </uploader-drop>
                      <uploader-list>
                        <div
                          slot-scope="props"
                        >
<!--                          <div class="file-title">-->
<!--                            <p class="file-list-title">文件列表</p>-->
<!--                          </div>-->

                          <ul
                            class="file-list"
                            :class="'uploader-list-ul-show'"
                          >
                            <li v-for="file in props.fileList" :key="file.id">
                              <uploader-file
                                :class="'file_' + file.id"
                                ref="files"
                                :file="file"
                                :list="true"
                                style="text-align: left"
                              >
                                {{file.name}}<a v-if="!file.error" href="#" @click="fileRemoved(file,'apply')" style="float: right;margin-right: 5px;">删除</a>
                              </uploader-file>
                            </li>
                          </ul>
                        </div>
                      </uploader-list>
                    </uploader>

                    <div class="editVideoDiv" v-if="option_flag == 'edit'" style="margin-top: 5px;">
                      <label>活页：</label>
                      <p class="fileListP" v-for="(att, index) in edit_live_file_data" :key="index">
                        <a @click="openFileModal(att.filePath)">{{att.fileName}}</a>
                        <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile('live', att.id)"></span>
                      </p>
                    </div>
                    <uploader :options="upload.liveOptions" :file-status-text="upload.statusText"
                              class="uploader-example" ref="liveFile" style="margin-top: 5px;">
                      <uploader-unsupport></uploader-unsupport>
                      <uploader-drop>
                        <p>拖拽活页至此处</p>
                        <uploader-btn :attrs="upload.attrs.file">上传活页</uploader-btn>
                      </uploader-drop>
                      <uploader-list>
                        <div
                          slot-scope="props"
                        >
                          <!--                          <div class="file-title">-->
                          <!--                            <p class="file-list-title">文件列表</p>-->
                          <!--                          </div>-->

                          <ul
                            class="file-list"
                            :class="'uploader-list-ul-show'"
                          >
                            <li v-for="file in props.fileList" :key="file.id">
                              <uploader-file
                                :class="'file_' + file.id"
                                ref="files"
                                :file="file"
                                :list="true"
                                style="text-align: left"
                              >
                                {{file.name}}<a v-if="!file.error" href="#" @click="fileRemoved(file,'live')" style="float: right;margin-right: 5px;">删除</a>
                              </uploader-file>
                            </li>
                          </ul>
                        </div>
                      </uploader-list>
                    </uploader>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="saveData()">确定</button>
                  <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
                </div>
              </div>
            </div>
          </div>

          <!--中期审核申请、结项审核申请、查看-->
          <div class="modal fade" id="projectView" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    {{ modalName }}
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>
                    <label>项目基本信息</label>
                    <table class="table table-striped table-bordered table_trainingManage">
<!--                      <thead>-->
<!--                      <tr>-->
<!--                        <th width="40%">项目名称</th>-->
<!--                        <th width="40%">项目来源</th>-->
<!--                        <th width="20%">操作</th>-->
<!--                      </tr>-->
<!--                      </thead>-->
                      <tbody>
                      <tr style="text-align: left;">
                        <td>项目名称</td>
                        <td>{{data.title}}</td>
                        <td>项目编号</td>
                        <td>{{data.code}}</td>
                      </tr>
                      <tr style="text-align: left;">
                        <td>立项时间</td>
                        <td>{{data.approvalDate}}</td>
                        <td>状态</td>
                        <td>{{statuses[data.status]}}</td>
                      </tr>
                      <tr style="text-align: left;">
                        <td>中期审核时间</td>
                        <td>{{data.mediumStartDate}}--{{data.mediumEndDate}}</td>
                        <td>结项评审时间</td>
                        <td>{{data.finalStartDate}}--{{data.finalEndDate}}</td>
                      </tr>
                      <tr style="text-align: left;">
                        <td>项目来源</td>
                        <td>{{data.source}}</td>
                        <td>立项文件</td>
                        <td>
                          <template v-for="item in edit_approval_file_data">
                            <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                            <a @click="downloadFile(item.filePath)">下载</a><br/>
                          </template>
                        </td>
                      </tr>
                      <tr style="text-align: left;">
                        <td>项目人员</td>
                        <td>
                          <span  v-if="data.personCharge">负责人：{{data.personCharge}}</span><br/>
                          <span  v-if="data.personPart">参与人：{{data.personPart}}</span>
                        </td>
                        <td>负责科室</td>
                        <td>{{data.dept}}</td>
                      </tr>
                      </tbody>
                    </table>

                    <div style="margin-top: 10px;">
                      <label>项目申请</label>
                      <p><span v-if="edit_apply_file_data.length>0">申请书&nbsp;&nbsp;&nbsp;</span>
                        <template v-for="item in edit_apply_file_data">
                          <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                          <a @click="downloadFile(item.filePath)">下载</a>&nbsp;&nbsp;&nbsp;
                        </template>
                      </p>
                      <p><span v-if="edit_live_file_data.length>0">活&nbsp;&nbsp;&nbsp;页&nbsp;&nbsp;&nbsp;</span>
                        <template v-for="item in edit_live_file_data">
                          <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                          <a @click="downloadFile(item.filePath)">下载</a>&nbsp;&nbsp;&nbsp;
                        </template>
                      </p>
                    </div>

                    <div style="margin-top: 10px;">
                      <label>
                        项目中期考核
                        <span v-if="data.status == '21'" style="color: green;">考核通过</span>
                        <span v-if="data.status == '22'" style="color: red;">考核未通过</span>
                      </label>
                      <p><span v-if="edit_medium_file_data.length>0">中期研究报告&nbsp;&nbsp;&nbsp;</span>
                        <template v-for="item in edit_medium_file_data">
                          <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                          <a @click="downloadFile(item.filePath)">下载</a>&nbsp;&nbsp;&nbsp;
                        </template>
                      </p>
                      <uploader v-if="data.status == '11' && modalName == '中期审核申请'" :options="upload.mediumOptions" :file-status-text="upload.statusText"
                                class="uploader-example" ref="mediumFile" style="margin-top: 5px;">
                        <uploader-unsupport></uploader-unsupport>
                        <uploader-drop>
                          <p>拖拽中期研究报告至此处</p>
                          <uploader-btn :attrs="upload.attrs.file">上传中期研究报告</uploader-btn>
                        </uploader-drop>
                        <uploader-list>
                          <div
                            slot-scope="props"
                          >
                            <!--                          <div class="file-title">-->
                            <!--                            <p class="file-list-title">文件列表</p>-->
                            <!--                          </div>-->

                            <ul
                              class="file-list"
                              :class="'uploader-list-ul-show'"
                            >
                              <li v-for="file in props.fileList" :key="file.id">
                                <uploader-file
                                  :class="'file_' + file.id"
                                  ref="files"
                                  :file="file"
                                  :list="true"
                                  style="text-align: left"
                                >
                                  {{file.name}}<a v-if="!file.error" href="#" @click="fileRemoved(file,'medium')" style="float: right;margin-right: 5px;">删除</a>
                                </uploader-file>
                              </li>
                            </ul>
                          </div>
                        </uploader-list>
                      </uploader>
                    </div>

                    <div style="margin-top: 10px;">
                      <label>
                        项目结项考核
<!--                        <span v-if="data.status == '32'" style="color: green;">考核通过</span>-->
<!--                        <span v-if="data.status == '31'" style="color: red;">考核未通过</span>-->
                      </label>
                      <p><span v-if="edit_final_file_data.length>0">结项报告&nbsp;&nbsp;&nbsp;</span>
                        <template v-for="item in edit_final_file_data">
                          <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                          <a @click="downloadFile(item.filePath)">下载</a>&nbsp;&nbsp;&nbsp;
                        </template>
                      </p>
                      <uploader v-if="data.status == '21' && modalName == '结项审核申请'" :options="upload.finalOptions" :file-status-text="upload.statusText"
                                class="uploader-example" ref="finalFile" style="margin-top: 5px;">
                        <uploader-unsupport></uploader-unsupport>
                        <uploader-drop>
                          <p>拖拽结项报告至此处</p>
                          <uploader-btn :attrs="upload.attrs.file">上传结项报告</uploader-btn>
                        </uploader-drop>
                        <uploader-list>
                          <div
                            slot-scope="props"
                          >
                            <!--                          <div class="file-title">-->
                            <!--                            <p class="file-list-title">文件列表</p>-->
                            <!--                          </div>-->

                            <ul
                              class="file-list"
                              :class="'uploader-list-ul-show'"
                            >
                              <li v-for="file in props.fileList" :key="file.id">
                                <uploader-file
                                  :class="'file_' + file.id"
                                  ref="files"
                                  :file="file"
                                  :list="true"
                                  style="text-align: left"
                                >
                                  {{file.name}}<a v-if="!file.error" href="#" @click="fileRemoved(file,'final')" style="float: right;margin-right: 5px;">删除</a>
                                </uploader-file>
                              </li>
                            </ul>
                          </div>
                        </uploader-list>
                      </uploader>
                    </div>

                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="updateStatus(data.id,data.status,modalName)" v-if="modalName !='查看'">确定</button>
                  <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
                </div>
              </div>
            </div>
          </div>

          <!--文档显示-->
          <div class="modal fade" id="myModal_showFile" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showFile" aria-hidden="true" data-backdrop='static'>
            <div class="modal-dialog modal-dialog-look">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_showFile">
                    文档预览
                  </h4>
                </div>
                <div class="modal-body modal-body-look">
                  <iframe :src="fileSrc" width="100%" height="700px"></iframe>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {schoolAxios} from '../main';
import {getContentSize} from './mainView';
import pageView from './pageView';

export default {
  name: "researchTeacher",
  components:{pageView},
  data() {
    return {
      clazzId: this.$store.state.clazzId,
      publishStatus: this.$store.state.publishStatus,
      classStatus: this.$store.state.classStatus,
      userId:this.$store.state.userId,
      resourcePath:  this.$store.state.serviceBase + "resources/",
      statuses:{
        "00": "未发布",
        "01": "已发布",
        "10": "已申请",
        "11": "已立项",
        "20": "中期审核",
        "21": "中期考核-通过",
        "22": "中期考核-未通过",
        "30": "结项考核",
        "31": "结项考核-未通过",
        "32": "已结项",
      },
      //今日日期
      timeDate: '',
      //培训人员集合
      dataList:[],
      publicshedDataList:[],

      option_flag: '',

      //培训人员对象
      data:{
        id:"",
        title:"",
        code:"",
        source:"",
        dept:"",
        personCharge:"",
        personPart:"",
        approvalDate:"",
        mediumStartDate:"",
        mediumEndDate:"",
        finalStartDate:"",
        finalEndDate:"",
        status:"",
        creator:"",
        userId:"",
        applicant:"",
        applicantId:"",
        createTime:""
      },
      searchParams: {
        title:'',
        all: 0,
        rows: 10,
        page:1
      },
      publishedSearchParams: {
        title:'',
        all: 0,
        rows: 10,
        page:1
      },

      hrefExport:this.$store.state.serviceBase+"resources/",

      fileSrc: '',
      edit_approval_file_data: [],//立项材料
      edit_apply_file_data: [],//申请书
      edit_live_file_data: [],//活页
      edit_medium_file_data: [],//中期研究报告
      edit_final_file_data: [],//结项材料

      //上传ID
      attachmentIds: '',
      //upload组件file的id与attachmentId对应关系集合[{fileId,fileType,attachmentId}]
      fileRelationshipArr: [],
      //上传
      upload: {
        applyFile: null,
        liveFile: null,
        mediumFile: null,
        finalFile: null,
        applyOptions: {
          target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
          maxChunkRetries: 3,
          method: 'post',
          headers: {
            'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
          },
          query: {
            attachmentType: 'pro_apply'
          },
          simultaneousUploads: 1,
          testChunks: false,
          chunkSize: 1024*1024,
        },
        liveOptions: {
          target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
          maxChunkRetries: 3,
          method: 'post',
          headers: {
            'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
          },
          query: {
            attachmentType: 'pro_live'
          },
          simultaneousUploads: 1,
          testChunks: false,
          chunkSize: 1024*1024,
        },
        mediumOptions: {
          target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
          maxChunkRetries: 3,
          method: 'post',
          headers: {
            'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
          },
          query: {
            attachmentType: 'pro_medium'
          },
          simultaneousUploads: 1,
          testChunks: false,
          chunkSize: 1024*1024,
        },
        finalOptions: {
          target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
          maxChunkRetries: 3,
          method: 'post',
          headers: {
            'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
          },
          query: {
            attachmentType: 'pro_final'
          },
          simultaneousUploads: 1,
          testChunks: false,
          chunkSize: 1024*1024,
        },
        attrs: {
          file: {
            accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf'
          },
        },
        statusText: {
          success: '成功了',
          error: '出错了',
          uploading: '上传中',
          paused: '暂停中',
          waiting: '等待中',
        },
      },
      modalName: '',
    }
  },


  mounted: function () {
    let this_ = this;
    this.$nextTick(function () {
      getContentSize();

      this_.initDataList();//日期
      // this_.initPublishedDataList();
      this_.dateDefault();
      //绑定加载关闭模态框时的事件
      this_.openModal();
      this_.closeModal();

      //获得上传组件对象
      this_.upload.applyFile = this_.$refs.applyFile.uploader;
      this_.upload.liveFile = this_.$refs.liveFile.uploader;

      this_.searchParams.page = 1;
      this_.searchParams.pageCallback = this_.initDataList;
      this_.loadUpload()
    });
  },
  methods: {

    initDataList(pageParams){
      let this_ = this;
      if(pageParams)
        Object.assign(this_.searchParams, pageParams);

      let _searchParams = {};
      Object.assign(_searchParams, this_.searchParams);
      delete _searchParams.pageCallback;//提交前删除回调
      console.log('--------_searchParams:',_searchParams)
      schoolAxios({
        method: 'get',
        url: 'research/teacherPage',
        params: _searchParams
      }).then(function (resp) {
        if(resp.data.success){
          this_.dataList = resp.data.list;
          this_.searchParams.all = resp.data.totalPage;
          this_.searchParams.page = 1;
        }
      });
    },
    initPublishedDataList(pageParams){
      let this_ = this;
      this_.publicshedDataList.length = 0
      if(pageParams)
        Object.assign(this_.publishedSearchParams, pageParams);

      let _searchParams = {};
      Object.assign(_searchParams, this_.publishedSearchParams);
      delete _searchParams.pageCallback;//提交前删除回调
      schoolAxios({
        method: 'get',
        url: 'research/publishedPage',
        params: _searchParams
      }).then(function (resp) {
        if(resp.data.success){
          this_.publicshedDataList = resp.data.list;
          this_.publishedSearchParams.all = resp.data.totalPage;
          this_.publishedSearchParams.page = 1;
        }
      });
    },


    saveData(){
      let this_ = this;
      console.log('------------------saveData:')
      this_.$validator.validateAll('scope').then(result => {
        if (result) {
          // let method = "";
          // let url = "";
          // if (this_.option_flag == "add") {
          //   method = "post";
          //   url = "research/add";
          // } else {
          //   method = "put";
          //   url = "research/edit";
          // }
          let data = Object.assign({}, this_.data, {attachmentIds: this_.attachmentIds,});
          data.createTime = ""
          delete data['attachments']
          console.log('------------------data:',data)
          schoolAxios({
            method: "put",
            url: "research/apply",
            data: data
          }).then(function (resp) {
            let data = resp.data;
            if (data.success) {
              $("#myModal").modal("hide");
              $("#publishedProject").modal("hide");
              this_.initDataList();
            } else {
              (data.message||"保存失败").showMessage();
            }
          });
        }
      });
    },

    applyProject(d){
      let this_ = this;
      this_.data = d;
      this_.option_flag = 'add';
      $("#myModal").modal("show");
      setTimeout(function () {
        this_.errors.clear('scope');
      });
    },

    projectView(d,title){
      let this_ = this;
      this_.edit_approval_file_data.length= 0
      this_.edit_apply_file_data.length= 0
      this_.edit_live_file_data.length= 0
      this_.edit_medium_file_data.length= 0
      this_.edit_final_file_data.length= 0
      this_.data = d;
      this_.modalName = title
      // this_.option_flag = 'add';
      schoolAxios({
        method: 'get',
        url: 'research/findAttachment',
        params: {objId:d.id}
      }).then(function (resp) {
        let data = resp.data;
        if(data.success){
          console.log('-------------findAttachment:',data.list)
          data.list[0].attachments.forEach(i => {
            if(i.fileType == 'pro_approval'){
              this_.edit_approval_file_data.push(i)
            }
            if(i.fileType == 'pro_apply'){
              this_.edit_apply_file_data.push(i)
            }
            if(i.fileType == 'pro_live'){
              this_.edit_live_file_data.push(i)
            }
            if(i.fileType == 'pro_medium'){
              this_.edit_medium_file_data.push(i)
            }
            if(i.fileType == 'pro_final'){
              this_.edit_final_file_data.push(i)
            }
          })
        }else{
          (data.message||"附件查询失败").showMessage();
        }
        $("#projectView").modal("show");
      })
    },


    /**
     * 拼接附件ID
     */
    splitAttachmentIds(attachmentIds){
      let this_ = this;
      if(this_.attachmentIds != ""){
        this_.attachmentIds += ",";
      }
      this_.attachmentIds += attachmentIds;
    },

    deleteAttachmentsFile(deleteFileType, id){
      let this_ = this;
      "确定删除".showConfirm(function () {
        schoolAxios({
          method: 'delete',
          url: 'upload/delete.action',
          params: {
            uploadAttachmentId: id
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            "删除成功".showMessage();
            if(deleteFileType == "apply"){
              //申请书
              let index = -1;
              for(let i=0; i<this_.edit_apply_file_data.length; i++){
                if(this_.edit_apply_file_data[i].id == id){
                  index = i;
                }
              }
              if(index >= 0){
                this_.edit_apply_file_data.splice(index, 1);
              }
            }else if(deleteFileType == "live"){
              //活页
              let index = -1;
              for(let i=0; i<this_.edit_live_file_data.length; i++){
                if(this_.edit_live_file_data[i].id == id){
                  index = i;
                }
              }
              if(index >= 0){
                this_.edit_live_file_data.splice(index, 1);
              }
            }else {

            }
          }else{
            "删除失败".showMessage();
          }
        })
      })
    },


    /**
     * 删除培训人员
     */
    deleteById(id){
      let this_ = this;
      "确定删除".showConfirm(function () {
        schoolAxios({
          method: 'delete',
          url: 'research/delete',
          params: {id:id}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            // "删除成功".showMessage();
            this_.initDataList();
          }else{
            (data.message||"删除失败").showMessage();
          }
        })
      })
    },

    /**
     * 修改状态
     */
    updateStatus(id, oldStatus, text){
      let this_ = this;
      let info = '确定提交' + text
      let newStatus = ''
      if(oldStatus == '11'){
        newStatus = '20'
      }
      if(oldStatus == '21'){
        newStatus = '30'
      }
      console.log('----------------updateStatus:',{id:id, status: newStatus, attachmentIds: this_.attachmentIds})
      info.showConfirm(function () {
        schoolAxios({
          method: 'put',
          url: 'research/updateStatus',
          params: {id:id, status: newStatus, attachmentIds: this_.attachmentIds}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            // "删除成功".showMessage();
            this_.initDataList();
            $("#projectView").modal("hide");
          }else{
            (data.message||"操作失败").showMessage();
          }
        })
      })
    },

    /**
     * 打开文件模态框
     */
    openFileModal(filePath) {
      let this_ = this;
      let data = filePath.substring(0, 11);
      let fileId = filePath.substring(11, filePath.indexOf('.'));
      this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
      console.log('-------------------fileSrc:',this_.fileSrc)
      $("#myModal_showFile").modal("show");
    },

    /**
     * 下载
     */
    downloadFile(filePath){
      let this_ = this;
      console.log('-------------------downloadFile:',this_.hrefExport+filePath)
      location.href=this_.hrefExport+filePath
    },

    /**
     * 关闭模态框监听
     */
    closeModal() {
      let this_ = this;
      $("#myModal").on('hide.bs.modal', function () {
        this_.searchTeacherName = '';
        this_.queryInputDataArr = [];
        this_.data = {
          id:"",
          title:"",
          code:"",
          source:"",
          dept:"",
          personCharge:"",
          personPart:"",
          approvalDate:"",
          mediumStartDate:"",
          mediumEndDate:"",
          finalStartDate:"",
          finalEndDate:"",
          status:"",
          creator:"",
          userId:"",
          applicant:"",
          applicantId:"",
          createTime:""
        },

          this_.attachmentIds = "";
          this_.upload.applyFile.cancel();
          this_.upload.liveFile.cancel();
        if(this_.upload.mediumFile != null){
          this_.upload.mediumFile.cancel();
        }
        if(this_.upload.finalFile != null) {
          this_.upload.finalFile.cancel();
        }

          this_.option_flag= 'add';
        setTimeout(function () {
          this_.errors.clear('scope');
        });

      });

      $("#projectView").on('hide.bs.modal', function () {
        this_.searchTeacherName = '';
        this_.queryInputDataArr = [];
        this_.data = {
          id:"",
          title:"",
          code:"",
          source:"",
          dept:"",
          personCharge:"",
          personPart:"",
          approvalDate:"",
          mediumStartDate:"",
          mediumEndDate:"",
          finalStartDate:"",
          finalEndDate:"",
          status:"",
          creator:"",
          userId:"",
          applicant:"",
          applicantId:"",
          createTime:""
        },

          this_.attachmentIds = "";
        this_.upload.applyFile.cancel();
        this_.upload.liveFile.cancel();
        if(this_.upload.mediumFile != null){
          this_.upload.mediumFile.cancel();
        }
        if(this_.upload.finalFile != null) {
          this_.upload.finalFile.cancel();
        }

        this_.option_flag= 'add';
        setTimeout(function () {
          this_.errors.clear('scope');
        });

      });

    },

    openModal(){
      let this_ = this;
      $("#publishedProject").on('show.bs.modal', function () {
        this_.initPublishedDataList()
      });
      $("#projectView").on('show.bs.modal', function () {
        if(this_.data.status == '11' && this_.modalName == '中期审核申请'){
          console.log('----------------------------projectView11')
          this_.upload.mediumFile = this_.$refs.mediumFile.uploader;
          this_.loadUploadMedium()
        }
        if(this_.data.status == '21' && this_.modalName == '结项审核申请') {
          console.log('----------------------------projectView21')
          this_.upload.finalFile = this_.$refs.finalFile.uploader;
          this_.loadUploadFinal()
        }
      });
    },
    /**
     * 初始化日期选这框
     */
    dateDefault(){
      let this_ = this;
      let date, nowDate;
      date = new Date();
      nowDate = date.getFullYear() + "-";
      nowDate += (date.getMonth() + 1) + "-";
      nowDate += date.getDate() + " ";
      this_.timeDate = nowDate;
      $('.datetimepicker').datetimepicker({
        minView: "month",
        language: 'zh-CN',
        format: 'yyyy-mm-dd',
        //startDate: this_.timeDate,
        weekStart: 0,
        todayBtn: true,
        clearBtn: true,
        autoclose: true,
        todayHighlight: true,
        startView: 2,
        forceParse: 0,
        showMeridian: 1,
      }).on('hide', function (ev) {
        let id = ev.delegateTarget.id;
        if(id == "startDate"){
          let value = $("#startDate").val();
          this_.data.startDate = value;
        }
        ev.preventDefault();
        ev.stopPropagation();
      });
    },

    /**
     * 上传加载
     */
    loadUpload(){
      let this_ = this;
      /**
       * 文件上传验证处理
       */
      this_.upload.applyFile.on('fileAdded', function (file, event) {
        if(this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
          (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
          return false;
        }
      });
      this_.upload.applyFile.on('fileSuccess', function (rootFile, file, message, chunk) {
        if(message){
          let message_ = JSON.parse(message);
          if(this_.attachmentIds != ""){
            this_.attachmentIds += ",";
          }
          this_.attachmentIds += message_.message;
          this_.fileRelationshipArr.push({fileId:file.id,fileType:'apply',attachmentId:message_.message})
        }
      });
      this_.upload.applyFile.on('fileComplete', function (rootFile) {
        console.info(rootFile);
      });
      this_.upload.applyFile.on('fileError', function (rootFile, file, message) {
        (file.name+"上传失败").showMessage();
      });

      this_.upload.liveFile.on('fileAdded', function (file, event) {
        if(this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
          (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
          return false;
        }
      });
      this_.upload.liveFile.on('fileSuccess', function (rootFile, file, message, chunk) {
        if(message){
          let message_ = JSON.parse(message);
          if(this_.attachmentIds != ""){
            this_.attachmentIds += ",";
          }
          this_.attachmentIds += message_.message;
          this_.fileRelationshipArr.push({fileId:file.id,fileType:'live',attachmentId:message_.message})
        }
      });
      this_.upload.liveFile.on('fileComplete', function (rootFile) {
        console.info(rootFile);
      });
      this_.upload.liveFile.on('fileError', function (rootFile, file, message) {
        (file.name+"上传失败").showMessage();
      });

    },

    loadUploadMedium(){
      let this_ = this;
      this_.upload.mediumFile.on('fileAdded', function (file, event) {
        if(this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
          (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
          return false;
        }
      });
      this_.upload.mediumFile.on('fileSuccess', function (rootFile, file, message, chunk) {
        if(message){
          let message_ = JSON.parse(message);
          if(this_.attachmentIds != ""){
            this_.attachmentIds += ",";
          }
          this_.attachmentIds += message_.message;
          this_.fileRelationshipArr.push({fileId:file.id,fileType:'medium',attachmentId:message_.message})
        }
      });
      this_.upload.mediumFile.on('fileComplete', function (rootFile) {
        console.info(rootFile);
      });
      this_.upload.mediumFile.on('fileError', function (rootFile, file, message) {
        (file.name+"上传失败").showMessage();
      });
    },
    loadUploadFinal(){
      let this_ = this;
      this_.upload.finalFile.on('fileAdded', function (file, event) {
        if(this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
          (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
          return false;
        }
      });
      this_.upload.finalFile.on('fileSuccess', function (rootFile, file, message, chunk) {
        if(message){
          let message_ = JSON.parse(message);
          if(this_.attachmentIds != ""){
            this_.attachmentIds += ",";
          }
          this_.attachmentIds += message_.message;
          this_.fileRelationshipArr.push({fileId:file.id,fileType:'final',attachmentId:message_.message})
        }
      });
      this_.upload.finalFile.on('fileComplete', function (rootFile) {
        console.info(rootFile);
      });
      this_.upload.finalFile.on('fileError', function (rootFile, file, message) {
        (file.name+"上传失败").showMessage();
      });
    },
    fileRemoved(file,type) {
      let this_ = this;
      if('apply' == type){
        this_.upload.applyFile.removeFile(file)
      }
      if('live' == type){
        this_.upload.liveFile.removeFile(file)
      }
      if('medium' == type){
        this_.upload.mediumFile.removeFile(file)
      }
      if('final' == type){
        this_.upload.finalFile.removeFile(file)
      }
      let arr = []
      let id = ''
      this_.fileRelationshipArr.forEach(i=>{
        if(i.fileType == type && i.fileId == file.id){
          //清理attachmentIds
          id = i.attachmentId
          this_.attachmentIds = this_.attachmentIds.replace(i.attachmentId,'_')
            .replace(',_','').replace('_,','').replace('_','')
        } else{
          arr.push(i)
        }
      })
      this_.fileRelationshipArr.length = 0
      this_.fileRelationshipArr = arr
      if(id != ''){
        schoolAxios({
          method: 'delete',
          url: 'upload/delete.action',
          params: {
            uploadAttachmentId: id
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            // "删除成功".showMessage();

          }else{
            // "删除失败".showMessage();
          }
        })
      }
    },
  }
}
</script>

<style scoped>
@import '../assets/css/plugins.css';
@import "../assets/css/publicStyle.css";
.body_top {
  margin: 20px 0;
}
.searcharea{
  width: 80%;
  float: right;
  text-align: right;
}
.searcharea .form-control{
  display: inline-block;
  width: 160px;
}
.searcharea button{
  width: 60px;
}
.table_trainingManage {
  margin: 20px 0 0 0;
}
table tr{
  text-align: center;
}
table th {
  background: #cccccc;
  text-align: center;
}
.table-striped {
  /*background-color: #D7D7D7;*/
}
.edit_pic {
  width: 29px;
  height: 22px;
  background-image: url("../assets/img/right/trainingManage/edit_mouseOver.png");
  background-size: 100% 100%;
  float: left;
  margin: 0 25px 0 25px;
}
.delete_pic {
  width: 29px;
  height: 22px;
  background-image: url("../assets/img/right/trainingManage/delete_mouseOver.png");
  background-size: 100% 100%;
  float: left;
}
.modelInput{
  height: 34px;
  width: 90%;
  margin-top: 2%;
  margin-left: 5%;
}

#time_div {
  position: absolute;
  left: 26px;
  width: 84%;
  border: 1px grey solid;
  background-color: white;
  display: none;
  z-index: 1;
}
#time_div option {
  height: 30px;
  line-height: 30px;
  text-align: left;
}
#time_div option:hover {
  background-color: grey;
}
.modal-body .form-control{
  display: inline-block;
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/researchTeacher.vue